export const contentModal = () => ({
  isOpen: false,
  videoUrl: null,
  videoType: null, // 'youtube' or 'vimeo'
  embedUrl: null,

  init() {
    // Get video URL from trigger element using x-ref
    if (this.$refs.trigger) {
      this.videoUrl = this.$refs.trigger.getAttribute("href") || this.$refs.trigger.getAttribute("data-video-url");
    }

    // Watch isOpen and manage iframe lifecycle
    this.$watch("isOpen", (value) => {
      if (value) {
        // Generate embed URL when opening
        this.detectVideoType();
      } else {
        // Immediately clear embedUrl to destroy iframe when closing
        this.embedUrl = null;
      }
    });
  },

  detectVideoType() {
    if (!this.videoUrl) return;

    // Check for YouTube
    if (this.videoUrl.includes("youtube.com") || this.videoUrl.includes("youtu.be")) {
      this.videoType = "youtube";
      this.embedUrl = this.getYouTubeEmbedUrl(this.videoUrl);
    }
    // Check for Vimeo
    else if (this.videoUrl.includes("vimeo.com")) {
      this.videoType = "vimeo";
      this.embedUrl = this.getVimeoEmbedUrl(this.videoUrl);
    }
  },

  getYouTubeEmbedUrl(url) {
    // Extract video ID from various YouTube URL formats
    let videoId = null;

    // youtube.com/watch?v=VIDEO_ID
    const watchMatch = url.match(/[?&]v=([^&]+)/);
    if (watchMatch) {
      videoId = watchMatch[1];
    }

    // youtu.be/VIDEO_ID
    const shortMatch = url.match(/youtu\.be\/([^?]+)/);
    if (shortMatch) {
      videoId = shortMatch[1];
    }

    if (videoId) {
      return `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&rel=0`;
    }

    return null;
  },

  getVimeoEmbedUrl(url) {
    // Extract video ID from Vimeo URL
    const match = url.match(/vimeo\.com\/(\d+)/);

    if (match && match[1]) {
      const videoId = match[1];
      return `https://player.vimeo.com/video/${videoId}?autoplay=1&dnt=1`;
    }

    return null;
  },

  openModal(event) {
    event.preventDefault();
    this.isOpen = true;
  },
});
